import {Component} from '@angular/core';
/**
 * \@title Basic icons
 */
export class IconOverviewExample {static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'icon-overview-example',
  templateUrl: 'icon-overview-example.html',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function IconOverviewExample_tsickle_Closure_declarations() {
/** @type {?} */
IconOverviewExample.decorators;
/**
 * @nocollapse
 * @type {?}
 */
IconOverviewExample.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
